<template>
  <div class="info" v-html="content">
  </div>
</template>
<script>
export default {
  name: 'Info',
  props: ['content'],
}
</script>
<style lang="scss">
  .info {
    ::-moz-selection { background: yellow; }
    ::selection { background: yellow; }
    background-color: rgba(0,0,0,0.8);
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    padding: 0 1em;
    font-weight: 400;
    font-size: 2.8vw;
    letter-spacing: -0.007em;
    line-height: 1.3;
    @media screen and (orientation: portrait) {
      font-size: 5vw;
    }
  }
</style>
